import { AlertProps } from 'antd/lib/alert';
import { orderBy } from 'lodash';
import React from 'react';

import {
  EmergencyScenarioTableFragment,
  getPropertyWithAccessPointsQuery,
  GpioMode,
} from '../../../../graphql/api/generated';

type AccessPoint = getPropertyWithAccessPointsQuery['property']['accessPoints'][0];
type EmergencyScenarioAccessPoint = EmergencyScenarioTableFragment['emergencyScenarioAccessPoints'][0];

export type AccessPointWithEmergencyPlan = AccessPoint & {
  totalRelays: number;
  emergencyScenarioAccessPoint?: EmergencyScenarioAccessPoint | null;
  alerts: AlertProps[];
}

interface IFormatAccessPointsWithEmergencyPlanArgs {
  accessPoints: AccessPoint[];
  emergencyScenarioAccessPoints: EmergencyScenarioAccessPoint[];
}

export function formatAccessPointsWithEmergencyPlan(args: IFormatAccessPointsWithEmergencyPlanArgs) {
  const { accessPoints, emergencyScenarioAccessPoints } = args;

  const formattedAccessPoints: AccessPointWithEmergencyPlan[] = accessPoints.map((accessPoint) => {
    const totalRelays = accessPoint.relays.filter(r => r.gpioMode === GpioMode.OUTPUT).length;
    const emergencyScenarioAccessPoint = emergencyScenarioAccessPoints.find(eap => (
      eap.accessPointId === accessPoint.accessPointId
    ));

    const { emergencyPlan, emergencyPlanConflicts = [] } = emergencyScenarioAccessPoint || {};

    const alerts: AlertProps[] = [];

    if (emergencyPlan && totalRelays === 0) {
      alerts.push({
        showIcon: true,
        type: 'warning',
        message: 'No relays assigned',
      });
    }

    for (const { conflictingAccessPoint } of emergencyPlanConflicts) {
      alerts.push({
        showIcon: true,
        type: 'error',
        message: (
          <>
            Emergency Plan conflicts with <strong>{conflictingAccessPoint.name}</strong>
          </>
        ),
      });
    }

    return { ...accessPoint, totalRelays, emergencyScenarioAccessPoint, alerts };
  });

  return orderBy(formattedAccessPoints, [
    a => a.emergencyScenarioAccessPoint?.emergencyPlanConflicts.length || 0,
    a => !!a.emergencyScenarioAccessPoint?.emergencyPlan && a.totalRelays === 0,
    a => a.emergencyScenarioAccessPoint?.emergencyPlan,
    a => a.name,
  ], ['desc', 'desc', 'asc', 'asc']);
}
